import React from 'react';
import { Col, Row, Typography, Layout } from 'antd';
import TramittaLogo from '../images/tramitta-logo.png';
import LegalChileLogo from '../images/legalchile.svg';
import NotFoundImg from '../images/img-not-found.svg';

const { Title } = Typography;
const { Header } = Layout;

const NotFound = () => {

  return (
    <>
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <div className="text-center ant-layout-content-custom">
        <Row className="mb-4">
          <Col md={12} className="mx-auto">
            <img src={NotFoundImg} alt="" className="mb-2" />
            <Title level={2}>Sitio no encontrado</Title>
            <p>Parece que no hemos podido encontrar lo que estás buscando</p>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NotFound;